<template>
  <div>
    <div class="user-index" ref="user">
      <div>
        <div class="title">我的</div>
        <div class="topPart">
          <div class="image-part clearfix">
            <span class="icon heard" @click.stop="toUserUrl('information')"></span>
            <p class="name" v-if="userInfo">用户：<span @click="toUserUrl('information')">{{userInfo.username}} ></span></p>
            <template v-if="!userInfo">
              <span class="btn" @click="opt('login')">登录</span><span class="btn" @click="opt('reg')">注册</span>
            </template>
          </div>
        </div>
        <div class="bottomPart">

          <ul class="list">
            <li @click="toUserTry('upload')">
              <div>
                <span class="icon auth"></span>实名认证
              </div>
              <span class="arrow"></span>
            </li>
            <li @click="toUserTry('buylist')">
              <div>
                <span class="icon buy"></span>购买记录
              </div>
              <span class="arrow"></span>
            </li>
            <li @click="toUserTry('selllist')">
              <div>
                <span class="icon sell"></span>出售记录
              </div>
              <span class="arrow"></span>
            </li>
            <!-- <li><span class="icon eva"></span>评估记录<span class="arrow"></span></li> -->
            <!-- <li><span class="icon recover"></span>回收记录<span class="arrow"></span></li> -->
          </ul>

          <ul class="list">
            <li @click="toUserTry('message')">
              <div>
                <span class="icon mes"></span>消息
              </div>
              <p><span class="red" v-if="userInfo&&userInfo.unReadCount>0"></span><span class="arrow"></span></p>
            </li>
            <li @click="newOpen()">
              <div>
                <span class="icon service"></span>在线客服
              </div>
              <span class="arrow"></span>
            </li>
          </ul>

        </div>
      </div>
    </div>
    <footBottom></footBottom>
  </div>
</template>

<script>
  // import { levelResource, tryResource } from '@/resource/resource'
  import { mapState, mapMutations } from 'vuex'
  import footBottom from '@/components/common/footer/foot'
  import BScroll from 'better-scroll'
  // const ERR_OK = 0

  export default {
    name: 'user',
    data () {
      return {
        aa: null,
        isTurn: false, // 控制刷新金额icon转到
        oneShow: false, // 签到成功弹层
        score: 0 // 签到得到的积分
      }
    },
    computed: {
      ...mapState([
            'userInfo', 'logined', 'service', 'config_info'
        ])
    },
    created () {
    },
    mounted () {
      this.$nextTick(() => {
        this._initScroll()
      })
    },
    activated () {
    },
    methods: {
      _initScroll() {
        if (!this.userScroll) {
          // window.alert(this.$refs.user.offsetHeight)
          this.userScroll = new BScroll(this.$refs.user, {
            click: true
          })
        } else {
          this.userScroll.refresh()
        }
      },
      opt (str) {
        if (str === 'login') {
          this.$router.push({path: '/login', query: {redirect: '/user'}})
        }
        if (str === 'try') {
          this.$router.push({path: '/try', query: {redirect: '/user'}})
        }
        if (str === 'reg') {
          this.$router.push({path: '/register', query: {redirect: '/user'}})
        }
      },
      // toDown () {
      //   this.$router.push('/appdown')
      // },
      toUserUrl (url) {
        // if (this.logined) {
        this.$router.push('/user/' + url)
        // } else {
        //   this.$router.push('/login')
        // }
      },
      toUserTry (url) {
        if (this.userInfo) {
          if (this.userInfo.user_type === 3) {
            this.$toast('抱歉，试玩账号不能进行该操作')
            return
          }
        }
        this.$router.push('/user/' + url)
      },
      // 试玩用户不能操作
      alertTry () {
        this.$toast('抱歉，试玩账号不能进行该操作')
      },
      newOpen () {
        if (this.config_info.service_repwd_url) {
          window.open(this.config_info.service_repwd_url)
        }
      },
      // 更新vuex状态信息
      ...mapMutations([
        // 'BALANCE',
        'RECORD_USERINFO',
        'LEVELINFO',
        'SERVICE'
      ]),
      tologin () {
        this.$router.push('/login')
      }
    },
    watch: {
      // 'userInfo': function (val, oldVal) {
      //   if (val && !this.levelInfo) {
      //     this.getLevelInfo()
      //   }
      // }
    },
    filters: {
      strNumber(num) {
        num += ''
        if (num.length > 6 && num.length < 9) {
          num = num.substring(0, num.length - 4)
          num += 'W'
        } if (num.length > 9) {
          num = num.substring(0, num.length - 8)
          num += '亿'
        }
        if (num.length === 9) {
          num = num.substring(0, num.length - 8)
          num += '亿'
        }
        return num
      }
    },
    components: {
      footBottom
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../../common/stylus/mixin";
  .user-index
    position fixed
    top 0
    left 0
    bottom 1.0rem
    width 100%
    overflow hidden
    .title
      padding 0.3rem 0
      background-color $blue
      text-align center
      font-size $font-size-l
      color #fff
      margin-bottom 0.24rem
    .topPart
      position relative
      width 100%
      .image-part
        background-color #fff
        padding 0 0.28rem
        height 1.6rem
        font-size $font-size-l
        color #ffffff
        box-sizing border-box
        display flex
        align-items center
        .icon
          width 1.32rem
          height 1.32rem
          background-size cover
          vertical-align top
          border-radius 50%
          &.heard
            bg-image('heard')
        .btn
          width 1.6rem
          height 0.72rem
          color #fff
          background $blue
          font-size $fz-t3
          line-height @height
          text-align center
          border-radius 0.08rem
          margin-left 0.8rem
        .name
          font-size $fz-t3
          padding-left 0.8rem
          color $c-b3
          & > span
            margin-left 0.16rem
            color $blue
            font-weight bold
          &.on
            font-size $fz-t3
            margin-top 0.2rem
    .bottomPart
      width 100%
      padding-bottom 0.4rem
      background-color #f4f4f4
      font-size $fz-t3
      color $c-b3
      .list
        background #fff
        margin-top 0.24rem
        & > li
          border-bottom 1px solid #f4f4f4
          line-height 0.88rem
          display flex
          align-items center
          justify-content space-between
          padding 0 0.28rem
          position relative
          & > p
            display flex
            align-items center
            .red
              margin-right 0.2rem
              width 0.16rem
              height 0.16rem
              background-color #cd3c29
              border-radius 50%
          .arrow, & > p .arrow
            // float right
            // right 0.28rem
            width 0.13rem
            height 0.23rem
            background-size 0.13rem 0.23rem
            bg-image('icon_arrow')
          & > div
            display flex
            align-items center
            .icon
              margin-right 0.24rem
              width 0.31rem
              height 0.4rem
              background-size 0.31rem 0.4rem
              &.auth, &.mes
                width 0.4rem
                height 0.3rem
                background-size 0.4rem 0.3rem
                bg-image('auth')
              &.mes
                bg-image('mes')
              &.buy
                bg-image('buy')
              &.sell
                bg-image('sell')
              &.eva
                bg-image('eva')
              &.recover
                width 0.3rem
                background-size 0.3rem 0.4rem
                bg-image('recover')
              &.service
                width 0.38rem
                background-size 0.38rem 0.4rem
                bg-image('service')
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue